import React, { useEffect } from 'react';
import LoginCard from '../auth/LoginCard';

/* Header login popup — the modal chrome (.modal > .modal-dialog.login-popup > .modal-content
   > .modal-body) around the shared <LoginCard/>, which now does the REAL backend login.
   On success LoginCard flips the header to logged-in; onSuccess={onClose} closes the popup. */
export default function LoginModal({ open, onClose }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <>
      <div className="modal show d-block" tabIndex="-1" role="dialog"
        onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
        <div className="modal-dialog modal-lg modal-dialog-centered login-popup" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <LoginCard onClose={onClose} onSuccess={onClose} />
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop show" onClick={onClose} />
    </>
  );
}
